"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUpdateCustomerMutation = exports.useUnsuspendCustomerMutation = exports.useSuspendCustomerMutation = exports.useGetCustomerQuery = exports.useGetCustomerAddressesQuery = exports.useDeleteCustomerAddressMutation = exports.useAddCustomerAddressMutation = exports.customersApi = void 0;
var react_1 = require("@reduxjs/toolkit/query/react");
var base_query_1 = require("./base_query");
var orders_1 = require("./orders");
// the customers list is served by the order service, so its tag has to be invalidated across api slices
var refreshCustomerList = function (_arg_1, _a) { return __awaiter(void 0, [_arg_1, _a], void 0, function (_arg, _b) {
    var dispatch = _b.dispatch, queryFulfilled = _b.queryFulfilled;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, queryFulfilled];
            case 1:
                _c.sent();
                dispatch(orders_1.ordersApi.util.invalidateTags(["CustomerSummary"]));
                return [2 /*return*/];
        }
    });
}); };
var customersApi = (0, react_1.createApi)({
    reducerPath: "customersApi",
    baseQuery: (0, base_query_1.authorisedBaseQuery)((_a = process.env.LETS_TRADE_USER_URL) !== null && _a !== void 0 ? _a : ""),
    refetchOnMountOrArgChange: 30,
    refetchOnFocus: true,
    tagTypes: ["Address", "Customer"],
    endpoints: function (builder) { return ({
        getCustomer: builder.query({
            query: function (customerId) { return ({ url: "v2/get/user", params: { _id: customerId } }); },
            transformResponse: function (response) { return (0, base_query_1.unwrapEnvelope)(response); },
            providesTags: function (_result, _error, customerId) { return [{ type: "Customer", id: customerId }]; },
        }),
        updateCustomer: builder.mutation({
            query: function (body) { return ({ url: "v2/update/user", method: "PUT", body: body }); },
            transformResponse: function (response) { return (0, base_query_1.unwrapEnvelope)(response); },
            invalidatesTags: function (_result, _error, body) { return [{ type: "Customer", id: body._id }]; },
        }),
        suspendCustomer: builder.mutation({
            query: function (customerId) { return ({ url: "v2/suspend/user", method: "PUT", body: { _id: customerId } }); },
            invalidatesTags: function (_result, _error, customerId) { return [{ type: "Customer", id: customerId }]; },
            onQueryStarted: refreshCustomerList,
        }),
        unsuspendCustomer: builder.mutation({
            query: function (customerId) { return ({ url: "v2/unsuspend/user", method: "PUT", body: { _id: customerId } }); },
            invalidatesTags: function (_result, _error, customerId) { return [{ type: "Customer", id: customerId }]; },
            onQueryStarted: refreshCustomerList,
        }),
        // the addresses routes are guarded by the user token, unlike the rest of this service
        getCustomerAddresses: builder.query({
            query: function (customerId) { return ({ url: "v2/address/list", params: { user_id: customerId } }); },
            extraOptions: { token: base_query_1.userToken },
            transformResponse: function (response) { var _a, _b; return (_b = (_a = (0, base_query_1.unwrapEnvelope)(response)) === null || _a === void 0 ? void 0 : _a.addresses) !== null && _b !== void 0 ? _b : []; },
            providesTags: function (_result, _error, customerId) { return [{ type: "Address", id: customerId }]; },
        }),
        addCustomerAddress: builder.mutation({
            query: function (body) { return ({ url: "v2/add/user/address", method: "POST", body: body }); },
            extraOptions: { token: base_query_1.userToken },
            invalidatesTags: function (_result, _error, _a) {
                var user_id = _a.user_id;
                return [{ type: "Address", id: user_id }];
            },
        }),
        // the route only needs the address id, but the owner comes along so the right list is invalidated
        deleteCustomerAddress: builder.mutation({
            query: function (_a) {
                var _id = _a._id;
                return ({ url: "v2/delete/address", method: "PUT", body: { _id: _id } });
            },
            extraOptions: { token: base_query_1.userToken },
            invalidatesTags: function (_result, _error, _a) {
                var user_id = _a.user_id;
                return [{ type: "Address", id: user_id }];
            },
        }),
    }); },
});
exports.customersApi = customersApi;
var useGetCustomerQuery = customersApi.useGetCustomerQuery, useUpdateCustomerMutation = customersApi.useUpdateCustomerMutation, useSuspendCustomerMutation = customersApi.useSuspendCustomerMutation, useUnsuspendCustomerMutation = customersApi.useUnsuspendCustomerMutation, useGetCustomerAddressesQuery = customersApi.useGetCustomerAddressesQuery, useAddCustomerAddressMutation = customersApi.useAddCustomerAddressMutation, useDeleteCustomerAddressMutation = customersApi.useDeleteCustomerAddressMutation;
exports.useGetCustomerQuery = useGetCustomerQuery;
exports.useUpdateCustomerMutation = useUpdateCustomerMutation;
exports.useSuspendCustomerMutation = useSuspendCustomerMutation;
exports.useUnsuspendCustomerMutation = useUnsuspendCustomerMutation;
exports.useGetCustomerAddressesQuery = useGetCustomerAddressesQuery;
exports.useAddCustomerAddressMutation = useAddCustomerAddressMutation;
exports.useDeleteCustomerAddressMutation = useDeleteCustomerAddressMutation;
